import {useState} from 'react';
import {Input} from 'antd';
import {updateCultivationRoomName} from "../../api/Api";

export const RoomNameWidget = ({room, onApiFail, onRefresh, props}) => {
    const [active, setActive] = useState(false);
    const [value, setValue] = useState(undefined);

    const onClick = () => {
        console.log('click')
        setValue(room.name)
        setActive(true);
    }

    const onChange = (e) => {
        setValue(e.target.value);
    }

    const sendName = () => {
        // don't allow the empty string
        const newValue = value === "" ? "Room" : value;
        updateCultivationRoomName(room.id, newValue).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const onBlur = () => {
        sendName();
        setActive(false);
    }

    const onMouseLeave = () => {
        sendName();
        setActive(false);
    }

    const divStyle = {
        cursor: 'pointer'
    }

    if (active === false) {
        return <div style={divStyle} onClick={onClick}>
            <b>
                {room.name}
            </b>
        </div>
    } else {
        return <Input value={value} onChange={onChange} onBlur={onBlur} onMouseLeave={onMouseLeave}/>
    }
}